import { render, staticRenderFns } from "./cabinet.vue?vue&type=template&id=40117e1c&scoped=true"
import script from "./cabinet.vue?vue&type=script&lang=ts"
export * from "./cabinet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40117e1c",
  null
  
)

export default component.exports